module.exports = __webpack_public_path__ + "img/Comments.7af71522.svg";